// ignore-string-externalization
import { useEffect } from 'react';
import { createMrktAppLanguage } from '@spotify-internal/event-definitions/es5/events/createMrktAppLanguage';
import { useRouter } from 'next/router';
import { eventSender } from '../../../../../src/features/Tracking/gabito';
import { useCurrentUser } from '../../../../../src/utils/CurrentUserProvider';

/** logs MrktAppLanguage event when locale changes */
export function MrktAppLanguageLogger() {
  const { locale = 'en' } = useRouter();
  const { isLoading, user } = useCurrentUser();

  useEffect(() => {
    if (isLoading) return;
    if (user) {
      eventSender.send(
        createMrktAppLanguage({
          language: locale,
        }),
      );
    }
  }, [locale, isLoading, user]);

  return null;
}
